import { EventInfo } from "@/types"
import DisplayCardComponent from "./display-card-component"

const RSVPCardComponent = (props: any) => {

    const e: EventInfo = props.event
    const updateFn = props.updateFn 

    return (
        <>
        <DisplayCardComponent 
            title={e.name} 
            buttonText={"RSVP"}
            buttonFn={() => {updateFn()}}
        >
            📅{e.date}&nbsp;&nbsp;🕕{e.start_time}-{e.end_time}<br />
            📌{e.location}
            <br /><br />
            {e.short_description}
        </DisplayCardComponent>

        </>
    )

}

export default RSVPCardComponent